import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    if (!user) {
      navigate('/admin/login', { replace: true });
      return;
    }

    // Check if user is admin
    if (user.role !== 'admin') {
      alert('الوصول مرفوض. هذه الصفحة مخصصة للمسؤولين فقط.');
      navigate('/', { replace: true });
      return;
    }
  }, [user, navigate]);

  // Don't render anything until authentication is verified
  if (!user || user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">جاري التحقق من الصلاحيات...</p>
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Header */}
      <header className="bg-gray-800 text-white shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-row-reverse justify-between items-center py-4">
            <Link to="/admin" className="text-2xl font-bold">
              🛠️ لوحة الإدارة
            </Link>
            
            <nav className="flex flex-row-reverse gap-6">
              <Link to="/admin" className="hover:text-gray-300">الرئيسية</Link>
              <Link to="/admin/products" className="hover:text-gray-300">المنتجات</Link>
              <Link to="/admin/orders" className="hover:text-gray-300">الطلبات</Link>
              <Link to="/admin/management" className="hover:text-gray-300">إدارة البيانات</Link>
              <Link to="/admin/users" className="hover:text-gray-300">إدارة المستخدمين</Link>
              <Link to="/" className="hover:text-gray-300">الموقع</Link>
              <button onClick={handleLogout} className="hover:text-gray-300">
                تسجيل خروج
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="min-h-screen">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
